import React from "react";
import './TauriLoader.css';

const TauriLoader = ({ borderSize, widthSize, heightSize }) => {
    return (
        <div className="tauri-loader"
            style={{
                '--tauri-loader-border-size': borderSize,
                '--tauri-loader-width': widthSize,
                '--tauri-loader-height': heightSize
            }}>
            <span className="loader"></span>
        </div>
    )
}

export default TauriLoader;
